import { Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";
import { SubHeader } from "../../utils/componentes-utiles/SubHeader";
import {
	getOpcionesAdmin,
	getPreparacionExportacionAccess,
} from "../../services/apis";
import { OpcionesMenuNav } from "../../utils/componentes-utiles/OpcionesMenuNav";

export const Admin = () => {
	const navigate = useNavigate();
	const [opciones, setOpciones] = useState([]);
	const [canAccessExportacion, setCanAccessExportacion] = useState(false);

	const cargarOpciones = async () => {
		try {
			const response = await getOpcionesAdmin();
			setOpciones(Array.isArray(response?.data) ? response.data : []);
		} catch (error) {
			console.error("Error al cargar las opciones de administracion:", error);
			setOpciones([]);
		}
	};

	const verificarAccesoExportacion = async () => {
		try {
			const response = await getPreparacionExportacionAccess();
			setCanAccessExportacion(Boolean(response?.success && response?.can_access));
		} catch (error) {
			if (error?.response?.status === 403) {
				setCanAccessExportacion(false);
				return;
			}

			console.error("Error verificando acceso a exportacion:", error);
			setCanAccessExportacion(false);
		}
	};

	useEffect(() => {
		cargarOpciones();
		verificarAccesoExportacion();
	}, []);

	return (
		<Grid
			container
			direction="row"
			justifyContent="center"
			alignItems="center"
			size={{ xs: 12 }}
		>
			<Grid
				container
				direction="column"
				justifyContent="start"
				alignItems="center"
				size={{ xs: 12 }}
				spacing={2}
				sx={{ minHeight: "65vh" }}
			>
				<SubHeader titulo={"Administracion"}></SubHeader>
				<OpcionesMenuNav opciones={opciones}></OpcionesMenuNav>

				{canAccessExportacion && (
					<Grid
						container
						direction="row"
						justifyContent="center"
						alignItems="start"
						size={{ xs: 12 }}
						sx={{ px: 2 }}
					>
						<Grid
							container
							direction="row"
							justifyContent="space-between"
							alignItems="center"
							size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }}
							gap={2}
							className="menu-card"
							onClick={() => navigate("/admin/preparar-exportacion-fichajes")}
						>
							<Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
								<IconButton size="large" color="primary">
									<FileUploadIcon sx={{ fontSize: 50 }} />
								</IconButton>
							</Grid>

							<Grid
								container
								direction="column"
								justifyContent="end"
								alignItems={{ xs: "start", sm: "end" }}
								size={{ xs: 12, sm: 9, md: 9, lg: 9 }}
							>
								<Typography variant="h5">PREPARAR EXPORTACION</Typography>
								<Typography variant="body2" color="text.secondary">
									Fichajes reconocidos
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};
